import React, { memo } from "react";
import { StyledVerticalNavigationItemsList } from "./styled";
import { IVerticalNavigationItemsListProps } from "./types";
import VerticalNavigationItem from "./VerticalNavigationItem";

const VerticalNavigationItemsList = ({
    items,
    selectedItemID,
    onChangeSelectedItem,
}: IVerticalNavigationItemsListProps) => {
    const selectedItemIndex = items.findIndex((i) => i.id === selectedItemID);
    const selectedItemPosition = selectedItemIndex >= 0 ? selectedItemIndex + 1 : 1;

    return (
        <StyledVerticalNavigationItemsList selectedItemPosition={selectedItemPosition}>
            {items.map((item) => (
                <VerticalNavigationItem
                    {...item}
                    key={item.id}
                    onClick={() => onChangeSelectedItem(item.id)}
                />
            ))}
        </StyledVerticalNavigationItemsList>
    );
};

export default memo(VerticalNavigationItemsList);
